import {Button, Container, styled} from "@mui/material";
import {PageHeader} from "components/Reports/components";
import {useEffect, useState} from "react";
import BusinessInfo from "./profileInner/BusinessInfo";
import AccountingInfo from "./profileInner/AccountingInfo";
import ProfileDetails from "./profileInner/ProfileDetails";
import API from "./profileInner/API";
import {Form, Formik} from "formik";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {apiUpdateProfile} from "api/appApi";
import {apiUpdateBussiness} from "api/businessApi";
import {appReset} from "../../store/actions/appAction";
import ChortkeOffline from "./profileInner/ChortkeOffline";
import Tabs from "components/Tabs";

const MainContainer = styled("div")(({theme}) => ({
    // height: '600px',
    backgroundColor: "#fff",
    borderRadius: theme.shape.borderRadius,
}));
const SubmitSection = styled("div")(({theme}) => ({
    width: "100%",
    bottom: 0,
    left: 0,
}));
const SubmitButtonContainer = styled("div")(({theme}) => ({
    backgroundColor: "white",
    height: "92px",
}));
const SubmitMargin = styled("div")(({theme}) => ({
    backgroundColor: theme.palette.disabled.light,
    height: "75px",
}));
const SumbmitButton = styled(Button)(({theme}) => ({
    width: "260px",
    height: "44px",
}));
const CancelButton = styled(Button)(({theme}) => ({
    width: "180px",
    height: "44px",
}));
const FormContainer = styled("div")(({theme}) => ({
    paddingTop: "45px",
    paddingBottom: "45px",
}));

// @ts-ignore
const ProfileComponent = ({type}) => {
    // @ts-ignore
    const businessState = useSelector((state) => state).businessReducer;
    // @ts-ignore
    const userState = useSelector((state) => state).userReducer;

    const tab =
        type === "settings"
            ? {
                title: "تنظیمات",
                description: "مدیریت اطلاعات کسب و کار",
            }
            : {
                title: "پروفایل",
                description: "مدیریت اطلاعات حساب کاربری",
            };

    const formTabs = [
        {
            title: "اطلاعات پروفایل",
            key: "profile-info",
            Component: ProfileDetails,
            action: true,
            requireBusiness: false,
        },
        {
            title: "اطلاعات کسب و کار",
            key: "business-settings",
            Component: BusinessInfo,
            action: true,
            requireBusiness: true,
        },
        {
            title: "اطلاعات حسابداری",
            key: "accounting-settings",
            Component: AccountingInfo,
            action: true,
            requireBusiness: true,
        },
        {
            title: "رابط برنامه نویسی (API)",
            key: "api",
            Component: API,
            action: false,
            requireBusiness: true,
        },
        {
            title: "فعالسازی آفلاین",
            key: "offline-chortke",
            Component: ChortkeOffline,
            action: false,
            requireBusiness: true,
        },
    ];
    // const formTabs = [
    //     {
    //         title: 'اطلاعات پروفایل',
    //         key: shortid.generate(),
    //         Component: ProfileDetails
    //     },
    //     {
    //         title: 'اطلاعات کسب و کار',
    //         key: "business-settings",
    //         Component: BusinessInfo
    //     },
    //     {
    //         title: 'اطلاعات حسابداری',
    //         key: "accounting-settings",
    //         Component: AccountingInfo
    //     },
    //     {
    //         title: 'API',
    //         key: "api",
    //         Component: API
    //     },
    // ]

    const [activeTab, setActiveTab] = useState(formTabs[0]);

    const {Component, action} = activeTab;
    const handleChange = (tab: (typeof formTabs)[0]) => {
        // setActiveTab(tab);
    };

    const token = businessState?.business?.token;
    const userToken = userState?.user?.token;

    const profileInitialValues = userState?.user;
    const businessInitialValues = businessState?.business?.business;

    const dispatch = useDispatch();

    const updateProfileSubmit = (values: any) => {
        // @ts-ignore
        dispatch(apiUpdateProfile(values, userToken, null));
    };

    const updateSettingSubmit = (values: any) => {
        // @ts-ignore
        dispatch(apiUpdateBussiness(values, token));
    };

    useEffect(() => {
        dispatch(appReset());
    }, []);

    // useEffect(() => {
    //     dispatch(apiGetBusiness(businessInitialValues, token));
    // }, [activeTab]);

    const navigate = useNavigate();

    return (
        <Formik
            initialValues={activeTab.title === "اطلاعات پروفایل" ? profileInitialValues : businessInitialValues}
            onSubmit={activeTab.title === "اطلاعات پروفایل" ? updateProfileSubmit : updateSettingSubmit}
            enableReinitialize={true}
        >
            {(formik) => (
                <Form>
                    <Container maxWidth="lg">
                        <div className="warp-table">
                            <div className="header-table">
                                <PageHeader tab={tab}/>
                            </div>
                            <MainContainer>
                                <Container maxWidth="md">
                                    <Tabs
                                        tabs={formTabs
                                            .filter(
                                                (f) =>
                                                    !f.requireBusiness ||
                                                    (f.requireBusiness && businessState.business && type === "settings")
                                            )
                                            .map((x) => ({label: x.title}))}
                                        onChange={(i) => {
                                            if (i === undefined) return;
                                            setActiveTab(formTabs[i]);
                                        }}
                                    />
                                    <FormContainer>{/* <Component key={activeTab.key} /> */}</FormContainer>
                                </Container>
                            </MainContainer>
                        </div>

                        {action && (
                            <>
                                <SubmitSection>
                                    <SubmitButtonContainer>
                                        <Container
                                            sx={{
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "row-reverse",
                                            }}
                                            maxWidth="lg"
                                        >
                                            <SumbmitButton
                                                type="submit"
                                                variant="contained"
                                                disableElevation
                                                startIcon={
                                                    <svg
                                                        width="17"
                                                        height="20"
                                                        viewBox="0 0 17 20"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M14.3335 0H2.72925C1.78417 0 0.954346 0.777477 0.954346 1.69775V18.8639C0.954346 19.172 1.04008 19.4287 1.17826 19.6271C1.34351 19.8642 1.60958 20.0001 1.8949 20C2.16465 20 2.45186 19.8799 2.71708 19.6534L7.90881 15.2453C8.06916 15.1084 8.29948 15.0299 8.53896 15.0299C8.77834 15.0299 9.0082 15.1084 9.16902 15.2457L14.3434 19.6527C14.6096 19.8799 14.877 20.0001 15.1462 20.0001C15.6016 20.0001 16.0455 19.6488 16.0455 18.864V1.69775C16.0455 0.777477 15.2786 0 14.3335 0Z"
                                                            fill="white"
                                                        />
                                                        <rect x="4.33325" y="5" width="9.16667" height="1.25" rx="0.625"
                                                              fill="#1062D0"/>
                                                    </svg>
                                                }
                                                disableRipple
                                                disableTouchRipple
                                            >
                                                &nbsp;&nbsp; ذخیره تغییرات
                                            </SumbmitButton>
                                            <div style={{padding: "15px"}}/>
                                            <CancelButton
                                                onClick={() => navigate("/")}
                                                variant="outlined"
                                                disableElevation
                                                disableRipple
                                                disableTouchRipple
                                            >
                                                بازگشت
                                            </CancelButton>
                                        </Container>
                                    </SubmitButtonContainer>
                                    <SubmitMargin/>
                                </SubmitSection>
                                <SubmitSection sx={{position: "initial"}}/>
                            </>
                        )}
                    </Container>
                </Form>
            )}
        </Formik>
    );
};

export default ProfileComponent;
